import { render, staticRenderFns } from "./CenterIndex.vue?vue&type=template&id=1bffa2fc&scoped=true"
import script from "./CenterIndex.vue?vue&type=script&lang=js"
export * from "./CenterIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bffa2fc",
  null
  
)

export default component.exports